import imageMap from './image-map.js';

const travelConfig = {
  flight : {
    name       : '飞机',
    icon       : imageMap.flight,
    title      : '航班号',
    departText : '患者登机',
    arriveText : '患者抵达'
  },

  train : {
    name       : '火车',
    icon       : imageMap.train,
    title      : '车次号',
    departText : '患者上车',
    arriveText : '患者抵达'
  },

  subway : {
    name       : '地铁',
    icon       : imageMap.subway,
    title      : '地铁线路',
    departText : '患者进站',
    arriveText : '患者出站'
  },

  coach : {
    name       : '长途客车/大巴',
    icon       : imageMap.coach,
    title      : '车次/线路/车牌号',
    departText : '患者上车',
    arriveText : '患者抵达'
  },

  bus : {
    name       : '公交车',
    icon       : imageMap.bus,
    title      : '公交线路/车牌号',
    departText : '患者上车',
    arriveText : '患者抵达'
  },

  taxi : {
    name       : '出租车',
    icon       : imageMap.taxi,
    title      : '车牌号',
    departText : '患者上车',
    arriveText : '患者下车'
  },

  ship : {
    name       : '轮船',
    icon       : imageMap.ship,
    title      : '轮渡号',
    departText : '患者上船',
    arriveText : '患者抵达'
  },

  other : {
    name       : '其他',
    icon       : imageMap.other,
    title      : '地点名称',
    departText : '患者出现',
    arriveText : '患者离开'
  }
};

export default travelConfig;



// WEBPACK FOOTER //
// ./src/projects/virusTrip/travel-config.js